<template>
  <div :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications transition-name="notification-list" transition-mode="out-in">
    </notifications>
    <transition style="position: relative" name="fade" mode="out-in">
      <router-view> </router-view>
    </transition>
    <modal name="carga" :clickToClose="false">
      <div class="contenido_modal">
        <br />
        <br />
        <br />
        <br />
        <br />
        <center>
          <loader
            style="position: absolute; padding-right: 5%; margin-bottom: 4%"
            name="ball-scale-multiple"
            color="#E3097E"
            scale="3"
          ></loader
          ><br />
          <h3 style="padding-top: 11%; color: #e3097e !important">Cargando</h3>
        </center>
      </div>
    </modal>
  </div>
</template>

<script>
// Loading some plugin css asynchronously
import("sweetalert2/dist/sweetalert2.css");
import("vue-notifyjs/themes/default.css");

export default {
  data() {
    return {
      events: ["click", "mousemove", "scroll", "keypress", "load"],

      warningTimer: null,
      logoutTimer: null,
    };
  },
  mounted() {
    document.body.classList.toggle("sidebar-mini");
    this.events.forEach(function (event) {
      window.addEventListener(event, this.resetTimer);
    }, this);

    window.addEventListener('storage', (e) => {
      this.cerrarSesion();
    }, this);

    this.setTimers();
  },
  methods: {
    setTimers: function () {
      this.warningTimer = setTimeout(this.warningMessage,  900000);
    },

    cerrarSesion:function(){
      if (this.$router.currentRoute.path != "/login") {
        // alert("Hemos cerrado tu sesión por cambiar los datos de AVANTI");
        localStorage.removeItem("token");
        localStorage.removeItem("usuario");
        localStorage.removeItem("rol");
        localStorage.removeItem("foto");
        localStorage.removeItem("email");
        localStorage.removeItem("nombre");
        this.$router.push("/");
      }
    },

    warningMessage: function () {
      if (this.$router.currentRoute.path != "/login") {
        alert("Hemos cerrado la sesión por inactividad, click en aceptar");
        localStorage.removeItem("token");
        localStorage.removeItem("usuario");
        localStorage.removeItem("rol");
        localStorage.removeItem("foto");
        localStorage.removeItem("email");
        localStorage.removeItem("nombre");
        this.$router.push("/");
      }
    },

    resetTimer: function () {
      clearTimeout(this.warningTimer);
      this.setTimers();
    },
  },
};
</script>
<style lang="scss">
.notifications.vue-notifyjs {
  .notification-list-move {
    transition: transform 0.3s, opacity 0.4s;
  }
  .notification-list-item {
    display: inline-block;
    margin-right: 10px;
  }
  .notification-list-enter-active,
  .notification-list-leave-active {
    transition: opacity 0.4s;
  }
  .notification-list-enter, .notification-list-leave-to /* .list-leave-active for <2.1.8 */ {
    opacity: 0;
  }
}

.pagina {
  font-family: "Source Sans Bold";
}

// modal {
//   background-color: rgba(0,0,0,0.5);
// }
</style>



// WEBPACK FOOTER //
// src/App.vue